import nav from "./components/nav";

nav();

if (document.querySelector("[data-aos]")) {
  import("./components/aos").then(init => init.default());
}

if (document.querySelector(".js-accordion")) {
  import("./components/accordion").then(init => init.default());
}

if (document.querySelector(".js-add-wrapper")) {
  import("./components/addWrapper").then(init => init.default());
}

if (document.querySelector(".js-alert")) {
  import("./components/alert").then(init => init.default());
}

if (document.querySelector(".js-badge-position")) {
  import("./components/badgePosition").then(init => init.default());
}

if (document.querySelector(".js-carousel")) {
  import("./components/carousel").then(init => init.default());
}

if (document.querySelector(".js-composite-field")) {
  import("./components/compositeField").then(init => init.default());
}

if (document.querySelector(".js-container-with-video")) {
  import("./components/containerWithVideo").then(init => init.default());
}

if (document.querySelector(".js-dropdown")) {
  import("./components/dropdown").then(init => init.default());
}

if (document.querySelector(".js-editions")) {
  import("./components/editions").then(init => init.default());
}

if (document.querySelector(".js-expandable-content")) {
  import("./components/expandableContent").then(init => init.default());
}

if (document.querySelector(".js-featured-cta-layout")) {
  import("./components/featuredCTALayout").then(init => init.default());
}

if (document.querySelector(".js-gallery")) {
  import("./components/gallery").then(init => init.default());
}

if (document.querySelector(".js-global-header")) {
  import("./components/globalHeader").then(init => init.default());
}

if (document.querySelector(".js-grid-carousel")) {
  import("./components/gridCarousel").then(init => init.default());
}

if (document.querySelector(".js-marquee")) {
  import("./components/marquee").then(init => init.default());
}

if (document.querySelector(".js-membership")) {
  import("./components/membership").then(init => init.default());
}

if (document.querySelector(".js-modal-trigger")) {
  import("./components/modalTrigger").then(init => init.default());
}

if (document.querySelector(".js-nested-link")) {
  import("./components/nestedLink").then(init => init.default());
}

if (document.querySelector(".js-popup")) {
  import("./components/popup").then(init => init.default());
}

if (document.querySelector(".js-set-aspect-ratio-class")) {
  import("./components/setAspectRatioClass").then(init => init.default());
}

if (document.querySelector(".js-share")) {
  import("./components/share").then(init => init.default());
}

if (document.querySelector("[id]")) {
  import("./components/smoothScroll").then(init => init.default());
}

if (document.querySelector(".js-tabs")) {
  import("./components/tabs").then(init => init.default());
}

if (document.querySelector(".js-video-with-facade")) {
  import("./components/video").then(init => init.default());
}
